import * as React from 'react'
import { TaskMainConnected } from './TaskMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskMainExamples = () => {
  return (
    <div className="TaskMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskMainConnected />
      </Provider>
    </div>
  )
}
